import React, { useEffect, useState } from "react";
import PageTitle from "../../shared/PageTitle";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { BlankString, BTN_SMALL_LOADER, HTTPStatusCodes, PWD_PATTERN } from "../../Constants";
import Loader from "../../shared/Loader";
import { PostData } from "../../helpers/Fetch";

export default function ResetPassword() {
  const [formDetails, setFormDetails] = useState<{ password: string, cpassword: string, access_code: string, hasError: boolean, message: string, code_error: boolean, pwd_error: boolean, cpwd_error: boolean }>({
    password: BlankString,
    cpassword: BlankString,
    access_code: BlankString,
    hasError: false,
    message: BlankString,
    code_error: false,
    pwd_error: false,
    cpwd_error: false
  });
  const [showSpinner, setShowSpinner] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (state === null) navigate("/ForgotPassword");
    window.history.replaceState({}, document.title);
  });

  function ChangeHandler(event: any) {
    setFormDetails({ ...formDetails, 
      [event.target.name]: event.target.value,
      hasError: false, 
      code_error: false,
      pwd_error: false,
      cpwd_error: false,
      message: BlankString
    });
  };

  function ResetPassword(event: any) {
    event.preventDefault();
    setFormDetails({ ...formDetails, hasError: false, code_error: false, pwd_error: false, cpwd_error: false});
    if(!formDetails.access_code){
      setFormDetails({ ...formDetails, 
        hasError: true, 
        code_error: true, 
        message: "You need to provide Access Code value" 
      });
      return;
    }
    if (!PWD_PATTERN.test(formDetails.password)){
      setFormDetails({ ...formDetails, 
        hasError: true, 
        pwd_error: true, 
        message: "Invalid password pattern, read instructions" 
      });
      return;
    }
    if (formDetails.password !== formDetails.cpassword){
      setFormDetails({ ...formDetails, 
        hasError: true, 
        cpwd_error: true, 
        message: "Password and confirm Password mismatch" 
      });
      return;
    }
    const requestOptions = {
      access_code: formDetails.access_code,
      password: formDetails.password,
      confirm_password: formDetails.cpassword,
    };
    setShowSpinner(true);
    PostData(requestOptions, `Security/ResetPassword`).then(response => {
      setShowSpinner(false);
      if (response.statusCode === HTTPStatusCodes.InternalServerError || response.statusCode === HTTPStatusCodes.BadRequest || response.statusCode === undefined) {
        setFormDetails({
          ...formDetails,
          hasError: true,
          message: (response.statusCode === HTTPStatusCodes.InternalServerError || response.statusCode === HTTPStatusCodes.BadRequest) ? response.data.errorMessage : response.errorMessage
        });
      }
      if(response.statusCode === HTTPStatusCodes.OK){
        const responseMessage: string = response.data.message;
        navigate("/Login",  { state: { successMessage: responseMessage } });
      }
    });
  };

  return (
    <>
      <PageTitle title="Reset Password" />
      <div className="container gp-container">
        <form noValidate>
          <div className="row">
            <div className="col-md-4">
              <div className={!formDetails.hasError ? "display-none" : "alert alert-danger"}>{formDetails.message}</div>
              <p className="input-info">
                <label>Access Code</label>
                <input
                  type="text"
                  name="access_code"
                  placeholder="Access Code"
                  onChange={ChangeHandler}
                  value={formDetails.access_code}
                  autoComplete="false"
                  className={formDetails.code_error == true ? "input-validation-error" : "error"} />
              </p>
              <p className="input-info">
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  onChange={ChangeHandler}
                  value={formDetails.password} 
                  autoComplete="false"
                  className={formDetails.pwd_error == true ? "input-validation-error" : "error"} />
              </p>
              <p className="input-info">
                <label>Confirm Password</label>
                <input
                  type="password"
                  name="cpassword"
                  placeholder="Confirm Password"
                  onChange={ChangeHandler}
                  value={formDetails.cpassword} 
                  autoComplete="false"
                  className={formDetails.cpwd_error == true ? "input-validation-error" : "error"} />
              </p>
              <div>
                <button type="submit" className="btn-sm btn-small" onClick={ResetPassword} disabled={showSpinner}>
                  Reset Password
                </button>
                <Loader size={BTN_SMALL_LOADER} loading={showSpinner} />
              </div>
              <div className="top-margin-5" style={{ marginBottom: 10 }}>
                <Link to="/Login" style={{ color: "#0000ff", fontSize: 15 }}>Login Page</Link> | <Link to="/ForgotPassword" style={{ color: "#0000ff", fontSize: 15 }}>Get Access Code</Link>
              </div>
            </div>
            <div className="col-md-8">
              <h2>Instructions</h2>
              <p className="free-text">Enter access code you must have received on registered mail id</p>
              <p className="free-text">Your password must be minimum of <strong>6</strong> characters long and <strong>must contain atleast one capital letter [A-Z], one lower letter [a-z], one digit [0-9] and one special character from the list [@$!%*?&]</strong></p>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};